import { TranslationKeys } from "types/locale";

export type CarPart =
  | "BONNET"
  | "FLWING"
  | "FRWING"
  | "FBUMPER"
  | "BBUMPER"
  | "FLDOOR"
  | "FRDOOR"
  | "BLWING"
  | "BRWING"
  | "BOOTLID"
  | "RRDOOR"
  | "RLDOOR"
  | "LHEADLAMP"
  | "RHEADLAMP"
  | "LTAILLAMP"
  | "RTAILLAMP"
  | "GRILLE"
  | "LMIRROR"
  | "RMIRROR"
  | "FWINDSHIELD"
  | "RWINDSHIELD";

export const CAR_PART_TRANSLATION_KEYS: Record<CarPart, TranslationKeys> = {
  BONNET: "damage_review.bonnet",
  FLWING: "damage_review.front_left_wing",
  FRWING: "damage_review.front_right_wing",
  FBUMPER: "damage_review.front_bumper",
  BBUMPER: "damage_review.rear_bumper",
  FLDOOR: "damage_review.front_left_door",
  FRDOOR: "damage_review.front_right_door",
  BLWING: "damage_review.rear_left_wing",
  BRWING: "damage_review.rear_right_wing",
  BOOTLID: "damage_review.bootlid",
  RRDOOR: "damage_review.rear_right_door",
  RLDOOR: "damage_review.rear_left_door",
  LHEADLAMP: "damage_review.left_headlight",
  RHEADLAMP: "damage_review.right_headlight",
  LTAILLAMP: "damage_review.left_tail_light",
  RTAILLAMP: "damage_review.right_tail_light",
  GRILLE: "damage_review.grille",
  LMIRROR: "damage_review.left_mirror",
  RMIRROR: "damage_review.right_mirror",
  FWINDSHIELD: "damage_review.front_windscreen",
  RWINDSHIELD: "damage_review.rear_windscreen",
} as const;
